<template>
  <component :is="componentName" v-model="val" :class="{'Choices--locked': checkMax }">
    <slot></slot>
  </component>
</template>

<script>
export default {
  props: {
    max: {
      type: [Number, null],
      default: null
    },
    type: {
      default: 'radio',
      validator (val) {
        return (val === 'radio' || val === 'checkbox')
      }
    }
  },
  data () {
    return {
      val: this.value,
      dirty: false
    }
  },
  watch: {
    'val': function (v) {
      this.$emit('input', v)
    }
  },
  computed: {
    checkMax () {
      const max = this.max

      if (max > 0 && this.val !== undefined) {
        return this.val.length === max
      }

      return false

    },
    componentName () {
      if (this.type === 'radio') return 'Radio-group'
      else if (this.type === 'checkbox') return 'Checkbox-group'
    }
  },
  mounted () {
    this.$once('input', val => this.dirty = true)
  }
}
</script>

<style>
.Choices--locked .Choice:not(.Choice--checked) {
  pointer-events: none;
  opacity: .7;
}
</style>
